import { type ReactNode } from "react";
import { SideBar } from "@/components";
import * as styles from "./side-bar-actions-dialog.css";
import { useTranslatable } from "@sunrise/translator";
import type { ActionsDialog } from "@sunrise/dialogs";
import { SideBarActionsButton } from "./side-bar-actions-button";
import { useKeyboardNavigation } from "@/modules/keyboard-navigation";

export type SideBarActionsDialogProps = ActionsDialog & {
  doClose: () => void;
};

export function SideBarActionsDialog({
  title,
  actions,
  doClose,
}: SideBarActionsDialogProps): ReactNode {
  const t = useTranslatable();
  const focusIndex = actions.findIndex((item) => !!item.initialFocus);
  const preferredChildFocusKey =
    focusIndex >= 0
      ? `side-bar-actions-dialog.button.${focusIndex}`
      : undefined;

  useKeyboardNavigation({
    onArrowLeft: doClose,
    isEnabled: true,
  });

  return (
    <SideBar
      shouldShow={true}
      focusKey="side-bar-actions-dialog.container"
      data-testid="side-bar-actions-dialog"
      preferredChildFocusKey={preferredChildFocusKey}
    >
      {(_handlers) => (
        <>
          <div className={styles.title}>{t(title)}</div>
          {actions.map((action, index) => (
            <SideBarActionsButton
              key={index.toString()}
              {...action}
              index={index}
              doClose={doClose}
            />
          ))}
        </>
      )}
    </SideBar>
  );
}
